import React from 'react';
import InstructorCard from './InstructorCard';

const InstructorGrid = ({ instructors = [], onCardClick }) => {
  if (!instructors.length) {
    return <div className="py-20 text-center font-pretendard text-[20px] text-[#888]">표시할 강사가 없습니다.</div>;
  }

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-6">
      {instructors.map((it) => (
        <InstructorCard
          key={it.id}
          id={it.id}
          name={it.name}
          specialty={it.specialty}
          profileImageUrl={it.profileImageUrl}
          onClick={onCardClick}
        />
      ))}
    </div>
  );
};

export default InstructorGrid;
